var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 33,
    viewBox: "0 0 21 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.25001C0 0.55965 0.571873 0 1.27732 0H6.38658C7.09202 0 7.66389 0.55965 7.66389 1.25001V6.25007C7.66389 6.94043 7.09202 7.50008 6.38658 7.50008H1.27732C0.571874 7.50008 0 6.94043 0 6.25007V1.25001Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.75C0 13.0597 0.571873 12.5 1.27732 12.5H6.38658C7.09202 12.5 7.66389 13.0597 7.66389 13.75V18.7501C7.66389 19.4404 7.09202 20.0001 6.38658 20.0001H1.27732C0.571874 20.0001 0 19.4404 0 18.7501V13.75Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.252C0 25.5616 0.571873 25.002 1.27732 25.002H6.38658C7.09202 25.002 7.66389 25.5616 7.66389 26.252V31.252C7.66389 31.9424 7.09202 32.502 6.38658 32.502H1.27732C0.571874 32.502 0 31.9424 0 31.252V26.252Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7729 1.25001C12.7729 0.55965 13.3448 0 14.0503 0H19.1595C19.865 0 20.4368 0.55965 20.4368 1.25001V6.25007C20.4368 6.94043 19.865 7.50008 19.1595 7.50008H14.0503C13.3448 7.50008 12.7729 6.94043 12.7729 6.25007V1.25001Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7729 13.75C12.7729 13.0597 13.3448 12.5 14.0503 12.5H19.1595C19.865 12.5 20.4368 13.0597 20.4368 13.75V18.7501C20.4368 19.4404 19.865 20.0001 19.1595 20.0001H14.0503C13.3448 20.0001 12.7729 19.4404 12.7729 18.7501V13.75Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7729 26.252C12.7729 25.5616 13.3448 25.002 14.0503 25.002H19.1595C19.865 25.002 20.4368 25.5616 20.4368 26.252V31.252C20.4368 31.9424 19.865 32.502 19.1595 32.502H14.0503C13.3448 32.502 12.7729 31.9424 12.7729 31.252V26.252Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragQuestion);
export default __webpack_public_path__ + "static/media/drag-question.f2af1ccc8f04cbf43d73d6bafa0f564d.svg";
export { ForwardRef as ReactComponent };